$(document).ready(function () {
  // Adjust background size with range input
  $('input[type="range"]').on('input', function () {
    const value = $(this).val() + '%';
    $('.aop--pattern-background-mainImage').css('background-size', value);
  });

  var dragging = false; // Flag to check if dragging is active
  var iX, iY;

  // On mousedown, enable dragging and record initial position
  $('.aop--rimage-wrapper').mousedown(function (e) {
    dragging = true; // Set dragging to true
    iX = e.clientX - this.offsetLeft;
    iY = e.clientY - this.offsetTop;
    this.setCapture && this.setCapture();
    return false; // Prevent default behavior
  });

  // Update background position when dragging
  $(document).mousemove(function (e) {
    if (dragging) { // Only execute when dragging
      var oX = e.clientX - iX;
      var oY = e.clientY - iY;
      $('.aop--pattern-background-mainImage').css('background-position', oX + '% ' + oY + '%');
      return false; // Prevent text selection
    }
  });

  // Stop dragging on mouseup
  $(document).mouseup(function () {
    if (dragging) { // Ensure it's only triggered when dragging
      dragging = false; // Reset the dragging flag
      $('.aop--rimage-wrapper')[0].releaseCapture && $('.aop--rimage-wrapper')[0].releaseCapture();
    }
  });
});


  document.addEventListener('DOMContentLoaded', function () {
    const images = document.querySelectorAll('img');
    images.forEach((image) => {
      if (image.alt.includes('hide-image')) {
        image.classList.add('hidden');
      }
    });
  });

  // Initialize the range slider with vertical orientation
  rangeSlider(document.querySelector('#range'), {
    orientation: 'vertical',
  });